export const GET_AUDIT_LOGS_REQUEST = 'GET_AUDIT_LOGS_REQUEST'
export const GET_AUDIT_LOGS_SUCCESS = 'GET_AUDIT_LOGS_SUCCESS'
export const GET_AUDIT_LOGS_FAIL = 'GET_AUDIT_LOGS_FAIL'
export const GET_AUDIT_LOGS_RESET = 'GET_AUDIT_LOGS_RESET'

export const GET_AUDIT_LOG_BY_ID_REQUEST = 'GET_AUDIT_LOG_BY_ID_REQUEST'
export const GET_AUDIT_LOG_BY_ID_SUCCESS = 'GET_AUDIT_LOG_BY_ID_SUCCESS'
export const GET_AUDIT_LOG_BY_ID_FAIL = 'GET_AUDIT_LOG_BY_ID_FAIL'
export const GET_AUDIT_LOG_BY_ID_RESET = 'GET_AUDIT_LOG_BY_ID_RESET'

export const GET_AUDIT_LOG_STATS_REQUEST = 'GET_AUDIT_LOG_STATS_REQUEST'
export const GET_AUDIT_LOG_STATS_SUCCESS = 'GET_AUDIT_LOG_STATS_SUCCESS'
export const GET_AUDIT_LOG_STATS_FAIL = 'GET_AUDIT_LOG_STATS_FAIL'

// Pending Reviews
export const GET_PENDING_REVIEWS_REQUEST = 'GET_PENDING_REVIEWS_REQUEST'
export const GET_PENDING_REVIEWS_SUCCESS = 'GET_PENDING_REVIEWS_SUCCESS'
export const GET_PENDING_REVIEWS_FAIL = 'GET_PENDING_REVIEWS_FAIL'

// Mark as Reviewed
export const MARK_AS_REVIEWED_REQUEST = 'MARK_AS_REVIEWED_REQUEST'
export const MARK_AS_REVIEWED_SUCCESS = 'MARK_AS_REVIEWED_SUCCESS'
export const MARK_AS_REVIEWED_FAIL = 'MARK_AS_REVIEWED_FAIL'
export const MARK_AS_REVIEWED_RESET = 'MARK_AS_REVIEWED_RESET'

// Security Alerts
export const GET_SECURITY_ALERTS_REQUEST = 'GET_SECURITY_ALERTS_REQUEST'
export const GET_SECURITY_ALERTS_SUCCESS = 'GET_SECURITY_ALERTS_SUCCESS'
export const GET_SECURITY_ALERTS_FAIL = 'GET_SECURITY_ALERTS_FAIL'

// User Activity
export const GET_USER_ACTIVITY_REQUEST = 'GET_USER_ACTIVITY_REQUEST'
export const GET_USER_ACTIVITY_SUCCESS = 'GET_USER_ACTIVITY_SUCCESS'
export const GET_USER_ACTIVITY_FAIL = 'GET_USER_ACTIVITY_FAIL'

// Export Audit Logs
export const EXPORT_AUDIT_LOGS_REQUEST = 'EXPORT_AUDIT_LOGS_REQUEST'
export const EXPORT_AUDIT_LOGS_SUCCESS = 'EXPORT_AUDIT_LOGS_SUCCESS'
export const EXPORT_AUDIT_LOGS_FAIL = 'EXPORT_AUDIT_LOGS_FAIL'

// Bulk Mark as Reviewed
export const BULK_MARK_REVIEWED_REQUEST = 'BULK_MARK_REVIEWED_REQUEST'
export const BULK_MARK_REVIEWED_SUCCESS = 'BULK_MARK_REVIEWED_SUCCESS'
export const BULK_MARK_REVIEWED_FAIL = 'BULK_MARK_REVIEWED_FAIL'
export const BULK_MARK_REVIEWED_RESET = 'BULK_MARK_REVIEWED_RESET'
